import { filter } from 'lodash';
import * as t from './actionTypes';

const initialState = {
    companies: [],
}

export default function (state = initialState, action) {
    switch (action.type) {
        case t.LOAD_COMPANIES:
            return Object.assign({}, state, {
                companies: action.payload
            });
        
        default:
            return state
    }
}